import { render } from "./Employee_Absenteeism.vue?vue&type=template&id=4f9bca4a"
import script from "./Employee_Absenteeism.vue?vue&type=script&lang=js"
export * from "./Employee_Absenteeism.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__